<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm08_part1"><strong>NICE N’EASY</strong><a id="page_2"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm08_part1.vue?6c8c39fa